module.exports = __webpack_public_path__ + "static/media/daycareBanner2.6161e77b.png";